import { render, staticRenderFns } from "./formabsent.vue?vue&type=template&id=5bca4a30&scoped=true&"
import script from "./formabsent.vue?vue&type=script&lang=js&"
export * from "./formabsent.vue?vue&type=script&lang=js&"
import style0 from "./formabsent.vue?vue&type=style&index=0&id=5bca4a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca4a30",
  null
  
)

export default component.exports